export default __webpack_public_path__ + "static/media/video.85d7bb38.mp4";